import { Link } from '@flippingbook/web.react-kit/dist/Link';
import type { FieldErrors, UseFormReturn } from 'react-hook-form';

import type { FormDataType, validationRules } from '@/hooks/useRegisterPage';
import { loc } from '@/localization';
import { Field } from '@/site/components/Field';

import { e } from './style.css';

export function Captcha(props: Captcha.Props) {
    const {
        refreshCaptcha,
        errors,
        captchaImageSrc,
        captchaImageWidth,
        captchaImageHeight,
        register,
        validationRules,
        isSubmitting,
    } = props;

    return (
        <div className={e.captcha}>
            <div className={e.captchaDescription}>
                {loc.Login.FillRequired} <Link onClick={refreshCaptcha}>{loc.Login.DoRefresh}</Link>
            </div>
            <div className={e.pairedFields}>
                <img
                    className={e.captchaImage}
                    src={captchaImageSrc}
                    width={captchaImageWidth}
                    height={captchaImageHeight}
                    alt=""
                />
                <Field
                    name="captcha"
                    type="text"
                    className={e.captchaTextField}
                    register={register}
                    errors={errors}
                    validationRules={validationRules}
                    readOnly={isSubmitting}
                />
            </div>
        </div>
    );
}

export namespace Captcha {
    export interface Props {
        refreshCaptcha: () => void;
        errors: FieldErrors<FormDataType>;
        captchaImageSrc: string;
        captchaImageWidth?: number;
        captchaImageHeight?: number;
        register: UseFormReturn<FormDataType>['register'];
        validationRules: typeof validationRules;
        isSubmitting: boolean;
    }
}
